import React, { useState, useEffect, useRef } from 'react'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import HttpService from '../../services/httpService';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { DownloadOutlined, EyeOutlined, CaretDownOutlined } from '@ant-design/icons';
import Tooltip from '@material-ui/core/Tooltip';
import BomTable from '../../components/bomTable';
import XLSX from 'xlsx';
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { getApprovedProjects } from '../../redux/actions/financeAction'
import { useSelector } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { CSVLink } from "react-csv";
import { getAllMaterials } from '../../redux/actions/vendorAction';
import AlertDialog from './dialogBoxPopUp';
import CustomizedDialogs from './approvelDialogBox';
import { FaEye } from "react-icons/fa";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';




const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  table: {
    minWidth: 650,
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const getButtonStyle = (disabled) => ({
  background: disabled ? "#ccc" : "#1C375D",
  margin: 5,
});
const buttonStyle = {
  background: "#1C375D",
  margin: 5,
  '&:hover': {
    backgroundColor: '#E7BAD0 !important', // Light Pink on hover
  },
  transition: "transform 0.3s ease-in-out",
  transform: "scale(1)",
};
const handleMouseEnter = (e) => {
  e.currentTarget.style.transform = "scale(1.05)";
};
const handleMouseLeave = (e) => {
  e.currentTarget.style.transform = "scale(1)";
};

const BOM = React.memo((props) => {

  const classes = useStyles();
  const { approvedProjects } = useSelector(state => state.finance)
  const { userDetails } = useSelector(state => state.user)
  const [selectedProject, setSelectedProject] = useState({})
  const [showCreateButton, setShowCreateButton] = useState(false)
  const [bomPendingForApproval, setBomPendingForApproval] = useState([])
  const [show,setShow] = useState(false)
  const [mounted, setMounted] = useState(false)
  const [viewBomTable, setViewBomTable] = useState(false)
  const [viewBomTablePendingApproval, setViewBomTablePendingApproval] = useState(false);
  const { allMaterials } = useSelector(state => state.vendor)
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogViewOpen, setDialogViewOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [bomType, setBomType] = useState('');
  const [isInitiationEnabled, setIsInitiationEnabled] = useState(false);
  const [isModularEnabled, setIsModularEnabled] = useState(false);
  const [isHardwareEnabled, setIsHardwareEnabled] = useState(false);
  const [isSnagBom, setIsSnagBom] = useState(false);
  const [isShowViewButton, setIsShowViewButton] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [submitBom, setSubmitBom] = useState([]);
  const menuRef = useRef(null); 
  const viewBomRef = useRef(null); 
  const [materials, setAllMaterials] = useState([]);



  const handleScrollToViewBom = () => {
    if (viewBomRef.current) {
      viewBomRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const csvHandleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const csvHandleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        csvHandleClose();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  useEffect(() => {
    getApprovedProjects()
    // eslint-disable-next-line
  }, [])

  const getApprovedProjects = async () => {
    try {
      props.setLoading(true)
      await props.getApprovedProjects()
      if (userDetails.roles.find(role => role.name === "Operation Head" || role.name === "BOM Manager")) {
        const result = await HttpService.getBomPendingForApproval();
        // Filter BOMs to make sure only unique ones based on projectId.code
        const uniqueBomPendingForApproval = result?.data
          .filter((value, index, self) => 
            index === self?.findIndex((t) => t?.projectId?.code === value?.projectId?.code)
          )
          // Check if materials are not empty for each BOM
          .filter(bom => bom?.materials && bom?.materials?.length > 0);
        setBomPendingForApproval(uniqueBomPendingForApproval);
      }
      props.setLoading(false)
    } catch (error) {
      console.error(error)
      props.setLoading(false)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong ", "error")
    }
  }
  const [projectStatus,setProjectStatus] = useState(null)
  const handleSelect = async (event, value) => {
    if (value) {
      if (!value.searchName)
        value.searchName = `${value.code}_${value.clientName}`
      setSelectedProject(value)
      setProjectStatus(value?.project_current_stage)
      setShowCreateButton((userDetails.roles.find(role => role.name === "Factory Bom" || role.name === "Site Bom")))
      setIsShowViewButton(userDetails.roles.find(role => role.name === "Operation Head" || role.name === "BOM Manager"))
      setShowBomTable(false)
      setViewBomTable(false)
      getBom(value?._id)
    }
  }
  const [csvData, setCsvData] = useState([])
  const [filename, setFilename] = useState({});
  const buttonRef = useRef(null);
  const headers = [
    { key: 'selectedRoom', label: 'Select Room' },
    { key: 'selectedScope', label: 'Select Scope' },
    { key: 'selectedSubCategory', label: 'Scope Sub category' },
    { key: 'selectedMaterial', label: 'Select Material' },
    { key: 'uom', label: 'UOM' },
    { key: 'quantity', label: 'Qty' },
  ];
  
  const sampleData = [
    {
      selectedRoom: 'Sample Room',
      selectedScope: 'Sample Scope',
      selectedSubCategory: 'Sample SubCategory',
      selectedMaterial: 'Sample Material',
      uom: 'Sample Unit',
      quantity: "Sample Quantity"
    },
    {
      selectedRoom: 'Sample Room',
      selectedScope: 'Sample Scope',
      selectedSubCategory: 'Laminate',
      selectedMaterial: 'Sample Material',
      uom: 'Sample Unit',
      quantity: "Sample Quantity"
    },
  ];

  const [approvedBy, setApprovedBy] = useState([]);
  const getApprovelData = async (projectId) => {
    try {
      const result = await HttpService.getPreviousBomForProject(projectId?._id);
      setApprovedBy(result);
    } catch (error) {
      props.setLoading(false)
      props.setSnackInfo('Error fetching previous data', 'error')
    }
  }  

  const [clickedProjectId, setClickedProjectId] = useState({});
  const downloadCSVBom = async (event, projectId, type) => {
    setClickedProjectId(projectId);
    setFilename({ code: projectId.code, name: projectId.clientName})
    props.setLoading(true)
    try {
      let result
      const bomMaterialLists = [];
      if (type !== "Previous") {
        result = await HttpService.getSavedProjectMaterialForBom(projectId?._id);
      } else {
        result = await HttpService.getPreviousBomForProject(projectId?._id)
      }
      props.setLoading(false)
      if(type !== "Previous") {

        // seprate download button for multiple BOM in one project.
        const materialData = result?.data || [];
        setSubmitBom(materialData);
        const hasInitiationBOM = materialData.some(item => item.bomType === "Initiation BOM-Carpentry BOM");
        const hasModularBOM = materialData.some(item => item.bomType === "Modular BOM");
        const hasSnagBOM = materialData.some(item => item.bomType === "Snag BOM")
        const hasHardwareBOM = materialData.some(item => item.bomType === "Hardware BOM");

        // Set the button enabled states based on the presence of the BOM types
        setIsInitiationEnabled(hasInitiationBOM);
        setIsModularEnabled(hasModularBOM);
        setIsSnagBom(hasSnagBOM);
        setIsHardwareEnabled(hasHardwareBOM);

        if (result?.data[0]?.materials.length > 0) {
          result?.data[0]?.materials.forEach((ele) => {
            bomMaterialLists.push({
              selectedRoom: ele.spaceNameId.name,
              selectedScope: ele.scopeId.name,
              selectedSubCategory: ele.subCategoryId.name,
              selectedMaterial: ele.materialId.name.replace(/"/g, '""'),
              uom: ele.unitType.name,
              quantity: ele.quantity
            });
          });
        }
      } else {
        if (result?.data?.materials.length > 0) {
          result?.data?.materials.forEach((ele) => {
            bomMaterialLists.push({
              selectedRoom: ele.spaceNameId.name,
              selectedScope: ele.scopeId.name,
              selectedSubCategory: ele.subCategoryId.name,
              selectedMaterial: ele.materialId.name.replace(/"/g, '""'),
              uom: ele.unitType.name,
              quantity: ele.quantity
            });
          });
        }
        setCsvData(bomMaterialLists)
        setTimeout(() => {
          buttonRef.current.link.click();
        });
      }
    } catch (error) {
      props.setLoading(false)
      props.setSnackInfo('Error fetching previous data', 'error')
    }
  }

  const bomCsvDownload = async (projectId, bomType) => {
    try {
      setFilename({ code: clickedProjectId.code, name: clickedProjectId.clientName, bomType: bomType})
        const matchedBomData = [];
        const bomMaterialLists = [];

        // Iterate over the submitBom array and check for matching bomType
        submitBom.forEach((bom) => {
          if (bom.bomType === bomType && bom.projectId === clickedProjectId._id) {
            matchedBomData.push(bom);
          }
        });

        if (matchedBomData[0]?.materials.length > 0) {
          matchedBomData[0]?.materials.forEach((ele) => {
            bomMaterialLists.push({
              selectedRoom: ele.spaceNameId.name,
              selectedScope: ele.scopeId.name,
              selectedSubCategory: ele.subCategoryId.name,
              selectedMaterial: ele.materialId.name.replace(/"/g, '""'),
              uom: ele.unitType.name,
              quantity: ele.quantity
            });
          });
        }
      setCsvData(bomMaterialLists)
      setTimeout(() => {
        buttonRef.current.link.click();
      });
      csvHandleClose();
    } catch (error) {
      console.log("error downloading bom", error)
    }
  }


  const [buttonClicked, setButtonClicked] = useState(false)
  const [viewBomType, setViewBomType] = useState("");
  const showViewBomTable = (clickBomType) => {
    setViewBomType(clickBomType);
    setButtonClicked(true);
    setShowBomTable(true);
  }

  const getBom = async (projectId) => {
    props.setLoading(true);
    try {
      
      setShow(true);
      const result = await HttpService.getSavedProjectMaterialForBom(projectId);
      props.setLoading(false);
  
      const materialsData = result?.data || [];
      const mappedMaterials = materialsData.map((item, index) => {
        return {
          id: item._id,
          status: item.status,
          deleted: item.deleted,
          materials: item.materials,
          projectId: item.projectId,
          bomType: item.bomType,
        };
      });
      // Check if all required BOM types are present
      const hasInitiationBOM = mappedMaterials.some(item => item.bomType === "Initiation BOM-Carpentry BOM");
      const hasModularBOM = mappedMaterials.some(item => item.bomType === "Modular BOM");
      const hasSnagBOM = mappedMaterials.some(item => item.bomType === "Snag BOM")
      const hasHardwareBOM = mappedMaterials.some(item => item.bomType === "Hardware BOM");
  
      // Set the button enabled states based on the presence of the BOM types
      setIsInitiationEnabled(hasInitiationBOM);
      setIsModularEnabled(hasModularBOM);
      setIsSnagBom(hasSnagBOM);
      setIsHardwareEnabled(hasHardwareBOM);

      const approveUser = userDetails.roles.find(role => role.name === "Operation Head" || role.name === "BOM Manager");
      const normalUser = userDetails.roles.find(role => role.name === "Factory Bom" || role.name === "Site Bom");
      if (materialsData.length > 0) {
        if (approveUser) {
          if (buttonClicked) {
            setShowBomTable(true);
            props.setLoading(true);
          }
        } else if (normalUser) {
          setShowBomTable(true);
          props.setLoading(true);
        }
      }
    } catch (error) {
      console.error(error);
      props.setLoading(false);
      props.setSnackInfo('Error fetching previous data', 'error');
    }
  };

  const [showBomTable, setShowBomTable] = useState(false)

  const uploadBom = (e) => {
    setShowBomTable(false)
    const file = e.target.files[0];
    if (file !== undefined) {
      props.setLoading(true)
      if (file.name.split('.').reverse()[0] === 'xlsx') {
        const reader = new FileReader();
        reader.onload = (evt) => {
          const bstr = evt.target.result;
          const workbook = XLSX.read(bstr, { type: "binary" });
          const sheetName = workbook.SheetNames[2]; // Assumes your data is in the third sheet
          const worksheet = workbook.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_csv(worksheet, { header: 1, defval: '' }); // Convert sheet to CSV
          
          const BomJsonData = convertToJson(data); // Convert CSV to JSON
          uploadBomJson(BomJsonData); // Upload JSON data
        };
        reader.readAsBinaryString(file);
      } else {
        props.setSnackInfo('Please upload the file in the correct format', "error");
        props.setLoading(false);
      }
    }
  };

  const getAllMaterials = async () => {
    props.setLoading(true)
    try {
      const result = await HttpService.getAllMaterialsNames();
      const materialNames = result.data.map(material => material.name);
      setAllMaterials(materialNames);
    } catch (error) {
      console.error(error)
      props.setLoading(false)
      props.setSnackInfo('Error fetching Materials/Hardware', 'error')
    }
  }

  useEffect(() => {
    getAllMaterials();
  }, []);

  const uploadBomJson = async (data) => {

    let missingMaterial = [];
    if (data.length > 0) {
      data.forEach(item => {
        let material = item['Select Material'];
        if (material && !materials.includes(material)) {
          missingMaterial.push(material);
        }
      });
    }
    if (missingMaterial.length > 0) {
      props.setLoading(false);
      const uniqueMaterials = Array.from(new Set(missingMaterial));
      setDialogMessage(`\n${uniqueMaterials.join("\n")}`);
      handleClickOpen();
      return; 
    }

    try {
      const newArray = data.map((obj) => {
        const newObj = { ...obj }; // Create a new object to avoid mutating the original one
        if (newObj.hasOwnProperty("Select Material")) {
          newObj["Select Material"] = newObj["Select Material"]
            ?.toLowerCase()
            ?.replace(/\b\w/g, (match) => match.toUpperCase());
        }
  
        return newObj;
      });
  
     // Send payload to backend, including the new fields and including BOM type
     const newArrayObj = {
      bomType: bomType,
      data: newArray,
    };
    let result;
    if(bomType === "Initiation BOM-Carpentry BOM") {
      result = await HttpService.uploadBomData(selectedProject?._id, newArrayObj);
      props.setSnackInfo("Initiation BOM-Carpentry BOM Upload success", "success");
  
    } else if(bomType === "Modular BOM") {
      result = await HttpService.uploadModularBomData(selectedProject?._id, newArrayObj);
      props.setSnackInfo("Modular BOM Upload success", "success");
    } else if (bomType === "Snag BOM") {
      result = await HttpService.uploadSnagBomData(selectedProject?._id, newArrayObj);
      props.setSnackInfo("Sang BOM Upload success", "success");
    }
  
      if (result.status === 201) {
        setMounted(!mounted);
        setShowBomTable(true); // Show BOM table on success
      }
    } catch (error) {
      props.setLoading(false);
      error.response
        ? props.setSnackInfo(error.response.data, "error")
        : props.setSnackInfo('Error while uploading BOM', "error");
      console.error(error);
    }
  };
  

  const convertToJson = (csv) => {
    const lines = csv.split("\n");
    const result = [];
    const headers = lines[0].split(","); // Extract column headers from the first row
  
    for (let i = 1; i < lines.length; i++) {
      const obj = {};
      const currentline = lines[i].split(",");
  
      // Map the headers to the current row's data
      for (let j = 0; j < headers.length; j++) {
        if (currentline[j]?.includes('"')) {
          let arr = currentline[j].split('"')[1];
          currentline[j] = arr.concat('"');
        }
        obj[headers[j]] = currentline[j]; // Assign the header as the key and currentline[j] as value
      }
  
      // Add object to the result
      result.push(obj);
    }
  
    return result; // Return JSON representation of the CSV
  };
  

  // Function to get list of boms  whose approval is pending
  const showBomApprovalPending = async () => {
    setViewBomTablePendingApproval(true);
    setViewBomTable(false);
  }

  // Check for valid role combination
  const hasInvalidRoleCombination = userDetails.roles.some(role =>
    (role.name === "BOM Executive" || role.name === "Site Bom") &&
    (userDetails.roles.some(innerRole => innerRole.name === "Operation Head" || innerRole.name === "BOM Manager"))
  );

  const handleClickOpen = () => {
    setDialogOpen(true);
  };
  const handleViewClickOpen = () => {
    setDialogViewOpen(true);
  };
  const handleClose = () => {
    setDialogOpen(false);
  };
  const handleViewClose = () => {
    setDialogViewOpen(false)
  };

  const getAllErpData = ()=>{
    setBomType("Hardware BOM");
    setShowBomTable(true)
  }
  const [allImosData, setAllImosData] = useState([]);
  const checkAndUploadImosBom = async (event) => {
    props.setLoading(true);
    const result = await HttpService.checkImosStatus(selectedProject?._id);
    if (result?.data?.bomExists === true) {
      props.setSnackInfo("Please wait till previous Hardware BOM is Approved", "error");
      props.setLoading(false);
      return;
    }
    const file = event.target.files[0];
    if (file) {
      
        const formData = new FormData();
        formData.append('file', file);
        try {
          props.setLoading(true)
            const response = await HttpService.uploadFile(formData);
     
            const s3Link = response.data.s3Link || response.data;
            if (s3Link) {
          
              await fetchFileData(s3Link);
            } else {
              console.warn('S3 link not found in response data');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            props.setSnackInfo("Problem in file uploading", "warning");
        }
    } else {
        console.warn('No file selected');
    }
  };
  const fetchFileData = async (fileUrl) => {
    try {
      const response = await HttpService.imosUploadBomData(fileUrl);
      let arr = response.data;
      const result = await HttpService.getAllRooms();
      const fetchedRooms = result.data;
      const AllErpMaterialDataArray = await allMaterials.map((material) => material.name);
      // Array to store unmatched materials
      let unmatchedMaterials = [];
      if (arr.length > 0 && arr[0].projectOrderName === selectedProject.searchName) {
        let finalArray = [];
        let finalObj = null;
        let finalRoomData = null;
        for (let i = 1; i < arr[0].materials.length; i++) {
          let material = arr[0].materials[i];
          for (let j = 1; j < material.orderNames.length; j++) {
            let materialName = material.material.split(" (")[0];
            let quantityData = material.orderNames[j].quantity;
            let orderNameData = material.orderNames[j].name.split("_").pop().replace(" ()", "");
            const normalize = (str) => str.toLowerCase().replace(/_/g, "");
            const small = normalize(materialName);
            const normalizedAllMaterials = AllErpMaterialDataArray.map(normalize);
            const normalizeString = (str) => str.toLowerCase().trim();
            const allRoomsDataLower = fetchedRooms.map((room) => normalizeString(room.name));
            const orderNameDataLower = normalizeString(orderNameData);
            if (allRoomsDataLower.includes(orderNameDataLower)) {
              finalRoomData = fetchedRooms.find((room) => normalizeString(room.name) === orderNameDataLower);
            }
            if (!normalizedAllMaterials.includes(small)) {
              // Store unmatched material
              unmatchedMaterials.push(materialName);
            } else {
              finalObj = allMaterials.find((material) => normalize(material.name) === small);
            }
            if (finalObj && finalRoomData) {
              let obj = {
                materialName: finalObj,
                room: finalRoomData,
                unit: quantityData,
              };
              finalArray.push(obj);
            }
          }
        }
        
        if (unmatchedMaterials.length > 0) {
          const uniqueMaterials = Array.from(new Set(unmatchedMaterials));
          setDialogMessage(`\n${uniqueMaterials.join("\n")}`);
          handleClickOpen();
          props.setLoading(false);
          return;
        }   
  
        setAllImosData(finalArray);
  
        if (response.status === 200) {
          setMounted(true);
          setShowBomTable(true);
          props.setLoading(false);
          props.setSnackInfo("Upload success", "success");
        }

      } else {
        props.setSnackInfo("Project number is not matching please select the correct project number and proceed further.", "warning");
        props.setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching file data:", error);
      props.setLoading(false);
    }
  };



  return (
    <>
      {userDetails.roles.find(role => role.name === "Operation Head" || role.name === "BOM Manager") ? <div style={{ fontSize: 18, marginBottom: 10 }}><b>View BOM</b></div> : <div style={{ fontSize: 18, marginBottom: 10 }}><b>Upload New BOM</b></div>}
      <div style={{display:"flex",flexDirection:"column"}} ref={viewBomRef}>
      <div style={{ marginBottom: 20 , display:"flex" }}>
        <Autocomplete
          value={selectedProject}
          onChange={handleSelect}
          id="bom"
          options={approvedProjects}
          getOptionLabel={(option) => option.searchName || ''}
          style={{ width: 500 }}
          renderInput={(params) => <TextField {...params} label="Search Project" variant="outlined" />}
        />
        <div style ={{marginLeft : "30px"}}>
        <h2>{show ? ' ' + (projectStatus ? ('Project Status' +" :" +" " + projectStatus) : '') : ''}</h2>
        </div>
        </div>
      </div>
      {
        showCreateButton && <div style={{ display: "flex" }}>
          <Button variant="contained" color="primary" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={() => { setShowBomTable(true); setViewBomTable(false); setViewBomTablePendingApproval(false); }}
            style={{
              background: projectStatus === "Completed" ? "#D3D4D9" : "#1C375D",
              color: "#FFF",
              margin: 5,
              opacity: 1,
              cursor: projectStatus === "Completed" ? 'not-allowed' : 'pointer',
            }}
            disabled={projectStatus === "Completed"}
          >
            Create BOM
          </Button>
          <input
            accept="*"
            className={classes.input}
            id="contained-button-file"
            onChange={uploadBom}
            type="file"
            disabled={projectStatus === "Completed"}
          />
          <label htmlFor="contained-button-file">
            {userDetails.roles.find(role => role.name === "BOM Executive") &&
              !userDetails.roles.some(role => role.name === "IMOS Manager" || role.name === "IMOS User") && (
                <Button variant="contained" color="primary"
                  style={{
                    background: projectStatus === "Completed" ? "#D3D4D9" : "#1C375D",
                    color: "#FFF",
                    margin: 5,
                    opacity: 1,
                    cursor: projectStatus === "Completed" ? 'not-allowed' : 'pointer',
                  }}
                  disabled={projectStatus === "Completed"}
                  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} component="span" onClick={() => setBomType("Initiation BOM-Carpentry BOM")} >
                  Initiation BOM-Carpentry BOM
                </Button>
              )}
          </label>
          <input
            accept="*"
            className={classes.input}
            id="modular-contained-button-file"
            onChange={uploadBom}
            type="file"
            disabled={projectStatus === "Completed"}
          />
          <label htmlFor="modular-contained-button-file">
            {userDetails.roles.find(role => role.name === "IMOS Manager" || role.name === "IMOS User") && (
              <Button variant="contained" color="primary" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} component="span" disabled={projectStatus === "Completed"} onClick={() => setBomType("Modular BOM")}
                style={{
                  background: projectStatus === "Completed" ? "#D3D4D9" : "#1C375D",
                  color: "#FFF",
                  margin: 5,
                  opacity: 1,
                  cursor: projectStatus === "Completed" ? 'not-allowed' : 'pointer',
                }}
              >
                Modular BOM
              </Button>
            )}
          </label>

            <input
              accept=".xlsx"
              className={classes.input}
              id="imos-hardware-button-file"
              onChange={checkAndUploadImosBom}
              type="file"
              disabled={projectStatus === "Completed"}
            />
            <label htmlFor="imos-hardware-button-file">
            {userDetails.roles.find(role => role.name === "IMOS Manager" || role.name === "IMOS User") && (
              <Button variant="contained" color="primary" onClick={getAllErpData} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} component="span" disabled={projectStatus === "Completed"}
                style={{
                  background: projectStatus === "Completed" ? "#D3D4D9" : "#1C375D",
                  color: "#FFF",
                  margin: 5,
                  opacity: 1,
                  cursor: projectStatus === "Completed" ? 'not-allowed' : 'pointer',
                }}
              >
                Hardware BOM
              </Button>
            )}
          </label>

          <input
            accept="*"
            className={classes.input}
            id="sang-contained-button-file"
            onChange={uploadBom}
            type="file"
            disabled={projectStatus === "Completed"}
          />
          <label htmlFor="sang-contained-button-file">
            {userDetails.roles.find(role => role.name === "BOM Executive") &&
              !userDetails.roles.some(role => role.name === "IMOS Manager" || role.name === "IMOS User") && (
                <Button variant="contained" color="primary" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} component="span" disabled={projectStatus === "Completed"} onClick={() => setBomType("Snag BOM")}
                  style={{
                    background: projectStatus === "Completed" ? "#D3D4D9" : "#1C375D",
                    color: "#FFF",
                    margin: 5,
                    opacity: 1,
                    cursor: projectStatus === "Completed" ? 'not-allowed' : 'pointer',
                  }}
                >
                  Snag BOM
                </Button>
              )}
          </label>
          {/* Download sample CSV */}
          <Tooltip title="Download sample BOM">
            <CSVLink
              data={sampleData}
              headers={headers}
              filename="sample_bom.xlsx"
              className="csv-download-button"
              target="_blank"
            >
              <IconButton color="primary">
                <DownloadOutlined style={{color: "#355025"}} />
              </IconButton>
            </CSVLink>
          </Tooltip>
        </div> 
      }
      {isShowViewButton && (
        <div style={{ display: "flex" }}>
          <Button
            variant="contained"
            color="primary"
            style={getButtonStyle(!isInitiationEnabled)}
            component="span"
            disabled={!isInitiationEnabled}
            onClick={() => showViewBomTable("Initiation BOM-Carpentry BOM")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
          Initiation BOM-Carpentry BOM
          </Button>
      
          <Button
            variant="contained"
            color="primary"
            style={getButtonStyle(!isModularEnabled)}
            component="span"
            disabled={!isModularEnabled}
            onClick={() => showViewBomTable("Modular BOM")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}

          >
            Modular BOM
          </Button>
      
          
          <Button
            variant="contained"
            color="primary"
            style={getButtonStyle(!isHardwareEnabled)}
            component="span"
            disabled={!isHardwareEnabled}
            onClick={() => showViewBomTable("Hardware BOM")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}

          >
            Hardware BOM
          </Button>

          <Button
            variant="contained"
            color="primary"
            style={getButtonStyle(!isSnagBom)}
            component="span"
            disabled={!isSnagBom}
            onClick={() => showViewBomTable("Snag BOM")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            Snag BOM
          </Button>
        </div>
      )}
      {showBomTable && <BomTable IomsData={allImosData} MOUNTED={mounted} SELECTEDPROJECT={selectedProject} TYPE={"CREATE"} BOMTYPE={bomType} VIEWBOMTYPE={viewBomType} BUTTONCLICKEDAPPROVED={buttonClicked} />}
      {
        !showBomTable && selectedProject?._id && <>
          <hr></hr>
          <div style={{ fontSize: 18, marginBottom: 10 }}><b>View Or Edit BOM</b></div>
        </>
      }
      {selectedProject?._id && <div style={{ display: "flex", marginBottom: 10 }}>
      <Button variant="contained" style={{ background: "#355025", margin: 5,color:"#FFF2EB" }} onClick={() => { setViewBomTable(true); setShowBomTable(false); setViewBomTablePendingApproval(false); getApprovelData(selectedProject);}}>
        View Previous BOM
        </Button>
        {viewBomTable && <>
          <Button onClick={() => downloadCSVBom(null, selectedProject, "Previous")} variant="contained" color="primary" style={{ background: "#355025", margin: 5, color:"#FFF2EB"}} >Download CSV<DownloadOutlined /></Button>
          <CSVLink headers={headers} filename={`${filename.code}-${filename.name}.csv`} data={csvData} style={{ color: "white" }} ref={buttonRef}> </CSVLink>
          <Tooltip title="Showing All Approved BOM list">
            <IconButton color="primary">
            <FaEye color="primary" style={{cursor:"pointer" }} onClick={handleViewClickOpen} />
            </IconButton>
          </Tooltip>
        </>
        }
      </div>
      }
      {selectedProject?._id && !hasInvalidRoleCombination && <div style={{ display: "flex", marginBottom: 10 }}>
        <Button variant="contained" color="primary" style={{ background: "#F47E46", margin: 5, color:"#FFF2EB" }} onClick={showBomApprovalPending}>
          Bom Pending Approval
        </Button>
      </div>
      }
      {viewBomTablePendingApproval &&
        <>
          <p><b>Bom Approval Pending List</b></p>
          <BomTable SELECTEDPROJECT={selectedProject} TYPE={"VIEW-PENDING"} />
        </>
      }
      {viewBomTable && <BomTable SELECTEDPROJECT={selectedProject} TYPE={"VIEW"} />}

      {
        !showBomTable && userDetails.roles.find(role => role.name === "BOM Manager" || role.name === "Operation Head") && bomPendingForApproval?.length > 0 &&
        <>
          <div style={{ fontSize: 18, marginBottom: 10 }}><b>Pending for approval</b></div>

          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Sl No</StyledTableCell>
                  <StyledTableCell align="center">Project Code</StyledTableCell>
                  <StyledTableCell align="center">Client Name</StyledTableCell>
                  <StyledTableCell align="center" colSpan={2}>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bomPendingForApproval?.map((data, i) => (
                  <StyledTableRow key={i + 1}>
                    <StyledTableCell component="th" scope="row">
                      {i + 1}
                    </StyledTableCell>
                    <StyledTableCell align="center">{data?.projectId?.code}</StyledTableCell>
                    <StyledTableCell align="center">{data?.projectId?.clientName}</StyledTableCell>
                      <StyledTableCell onClick={() => handleSelect(null, data?.projectId)} align="center"><button className='btn' 
                      onClick={() => {
                        handleSelect(null, data?.projectId);
                        handleScrollToViewBom();
                      }} 
                    >
                      View <EyeOutlined style={{color: "#FDB913"}}/>
                    </button>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <button variant="contained" className='btn' onClick={(e) => {downloadCSVBom(null, data?.projectId); csvHandleClick(e)} } >
                          Download BOMs <CaretDownOutlined />
                        </button>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={csvHandleClose}
                          sx={{
                            boxShadow: 'none',
                            '& .MuiPaper-root': {
                              boxShadow: 'none',
                            }
                          }}
                        >
                          <MenuItem>
                            <Button
                              variant="contained"
                              color="primary"
                              style={getButtonStyle(!isInitiationEnabled)}
                              component="span"
                              disabled={!isInitiationEnabled}
                              onClick={() => bomCsvDownload(data?.projectId, "Initiation BOM-Carpentry BOM")}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                              onClose={csvHandleClose}
                            >
                              Initiation BOM-Carpentry BOM {" "}<DownloadOutlined />
                            </Button>
                          </MenuItem>
                          <MenuItem>
                            <Button
                            variant="contained"
                            color="primary"
                            style={getButtonStyle(!isModularEnabled)}
                            component="span"
                            disabled={!isModularEnabled}
                            onClick={() => bomCsvDownload(data?.projectId, "Modular BOM")}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            onClose={csvHandleClose}
                            >
                              Modular BOM {" "}<DownloadOutlined />
                            </Button>
                          </MenuItem>
                          <MenuItem>
                          <Button
                            variant="contained"
                            color="primary"
                            style={getButtonStyle(!isHardwareEnabled)}
                            component="span"
                            disabled={!isHardwareEnabled}
                            onClick={() => bomCsvDownload(data?.projectId, "Hardware BOM")}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            onClose={csvHandleClose}
                          >
                            Hardware BOM {" "}<DownloadOutlined />
                          </Button>
                          </MenuItem>

                          <MenuItem>
                            <Button
                              variant="contained"
                              color="primary"
                              style={getButtonStyle(!isSnagBom)}
                              component="span"
                              disabled={!isSnagBom}
                              onClick={() => bomCsvDownload(data?.projectId, "Snag BOM")}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                              onClose={csvHandleClose}
                            >
                              Snag BOM {" "}<DownloadOutlined />
                            </Button>
                          </MenuItem>
                        </Menu>
                      </StyledTableCell>
                    <CSVLink headers={headers} filename={`${filename.code}-${filename.name}-${filename.bomType}.csv`} data={csvData} style={{ color: "white" }} ref={buttonRef}> </CSVLink>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      }
      <AlertDialog 
        open={dialogOpen} 
        onClose={handleClose} 
        message={dialogMessage} 
      />
      <CustomizedDialogs 
        open={dialogViewOpen} 
        onClose={handleViewClose} 
        allData={approvedBy}
      />
    </>
  )
})

export default connect(null, { setLoading, getApprovedProjects, setSnackInfo, getAllMaterials })(BOM);
